import { createSlice } from "@reduxjs/toolkit";

const theme = [
    'light',
    'dark',
    'blue',
    'dark-blue',
    'green',
    'orange',
    'pink',
    'dark-sidebar',
]

const fonts = [
    '"Poppins", sans-serif',
    '"Roboto", sans-serif',
    '"Montserrat", sans-serif',
]

const initialState = {
    selectTheme: JSON.parse(window.localStorage.getItem('theme')) ?? 'light',
    selectFont: JSON.parse(window.localStorage.getItem('font')) ?? '"Roboto", sans-serif',
    sidebar: true,
    addTask: false,
    notification: false,
    notifyMessage: false,
    settings: false
}

const settingssSlice = createSlice({
    name: 'settings',
    initialState,
    reducers:{
        darkMode(state, action){
            const themeIndex = theme.indexOf(action.payload)
            if (themeIndex !== -1){
                state.selectTheme = action.payload
                localStorage.setItem('theme', JSON.stringify(action.payload))
            }
        },
        changeTheme(state, action){
            const themeIndex = theme.indexOf(action.payload)
            if (themeIndex !== -1){
                state.selectTheme = action.payload
                localStorage.setItem('theme', JSON.stringify(action.payload))
            }
        },
        changeFont(state, action) {
            const fontIndex = fonts.indexOf(action.payload);
            if (fontIndex !== -1) {
                state.selectFont = action.payload;
                document.body.style.fontFamily = action.payload; 
                localStorage.setItem('font', JSON.stringify(action.payload));
            }
        },
        setSideBar(state, action){
            state.sidebar = action.payload
        },
        setAddTask(state, action){
            state.addTask = action.payload
        },
        showNotification(state, action){
            state.notification = action.payload
        },
        showMessage(state, action){
            state.notifyMessage = action.payload
        },
        openSettings(state, action){
            state.settings = action.payload
        },
    }
})

export const toggleTheme = (val)=>{
    return dispatch => {
        dispatch(settingssSlice.actions.changeTheme(val))
    }
}

export const toggleDarkMode = (val)=>{
    return dispatch => {
        dispatch(settingssSlice.actions.darkMode(val))
    }
}

export const toggleSideBar = (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.setSideBar(val))
    }
}

export const toggleAddTask = (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.setAddTask(val))
    }
}

export const toggleNotification = (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.showNotification(val))
    }
}

export const toggleMessage = (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.showMessage(val))
    }
}

export const toggleSettings= (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.openSettings(val))
    }
}

export const toggleFont= (val)=>{
    return dispach => {
        dispach(settingssSlice.actions.changeFont(val))
    }
}


export default settingssSlice.reducer